import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { formatAssetsUrl, formatDataTestId, renderSanitizedHtml } from '@whitbread-eos/utils';
import Image from 'next/image';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var baseDataTestId = 'WhyUs';
export default function WhyUs(_ref) {
  var data = _ref.data;
  var title = data.title,
    description = data.description,
    picture = data.picture,
    whyItems = data.whyItems;
  var itemsStyle = whyItems.length === 4 ? fourStyle : sixStyle;
  return _jsxs(Flex, _objectSpread(_objectSpread({}, sectionStyle), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper'),
    children: [_jsxs(Box, _objectSpread(_objectSpread({}, leftStyle), {}, {
      children: [_jsx(Heading, _objectSpread(_objectSpread({
        as: "h2"
      }, headingStyle), {}, {
        "data-testid": formatDataTestId(baseDataTestId, 'Title'),
        children: title
      })), _jsx(Text, {
        "data-testid": formatDataTestId(baseDataTestId, 'Description'),
        children: description
      }), whyItems.length > 0 && _jsx(Box, _objectSpread(_objectSpread({}, itemsStyle), {}, {
        children: whyItems.map(item => _jsx(WhyUsBox, {
          item: item
        }, "why-us-box-".concat(item.itemTitle)))
      }))]
    })), _jsx(Box, _objectSpread(_objectSpread({}, pictureStyle), {}, {
      children: _jsx(Image, {
        "data-testid": formatDataTestId(baseDataTestId, 'Image'),
        src: formatAssetsUrl(picture),
        alt: title,
        style: imageStyle,
        width: 700,
        height: 600,
        objectFit: "contain"
      })
    }))]
  }));
}
function WhyUsBox(_ref2) {
  var _item$itemTitle;
  var item = _ref2.item;
  return _jsxs(Box, _objectSpread(_objectSpread({}, itemStyle), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'Item'),
    children: [_jsx(Image, {
      width: 32,
      height: 32,
      alt: (_item$itemTitle = item === null || item === void 0 ? void 0 : item.itemTitle) !== null && _item$itemTitle !== void 0 ? _item$itemTitle : '',
      src: formatAssetsUrl(item === null || item === void 0 ? void 0 : item.itemIcon)
    }), _jsx(Heading, _objectSpread(_objectSpread({
      as: "h4"
    }, itemTitleStyle), {}, {
      children: item.itemTitle
    })), _jsx(Box, {
      className: "formatLinks",
      children: renderSanitizedHtml(item.itemDescription)
    })]
  }));
}
var sectionStyle = {
  justifyContent: 'space-between',
  flexDirection: {
    mobile: 'column-reverse',
    xs: 'column-reverse',
    sm: 'column',
    md: 'column',
    lg: 'row',
    xl: 'row'
  },
  align: 'flex-end',
  p: 'var(--chakra-space-xl) 0',
  alignItems: 'flex-start',
  gap: '1.5rem'
};
var itemStyle = {
  display: 'flex',
  flexDirection: 'column'
};
var itemTitleStyle = {
  fontSize: '1.1rem',
  fontWeight: '700',
  lineHeight: '1.3rem',
  color: 'tertiary',
  m: 'var(--chakra-space-sm) 0'
};
var leftStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1
};
var sixStyle = {
  display: 'grid',
  gridTemplateColumns: {
    mobile: 'repeat(1, minmax(0, 1fr))',
    sm: 'repeat(3, minmax(0, 1fr))'
  },
  gap: 6,
  mt: 'var(--chakra-space-md)'
};
var fourStyle = {
  display: 'grid',
  gridTemplateColumns: {
    mobile: 'repeat(1, minmax(0, 1fr))',
    sm: 'repeat(2, minmax(0, 1fr))'
  },
  gap: 6,
  mt: 'var(--chakra-space-md)'
};
var pictureStyle = {
  width: '100%',
  flex: 1,
  borderRadius: 'md',
  overflow: 'hidden',
  position: 'relative'
};
var imageStyle = {
  width: '100%',
  height: '100%'
};
var headingStyle = {
  fontSize: '1.8rem',
  fontWeight: '900',
  lineHeight: '2rem',
  color: 'tertiary',
  marginBottom: 'var(--chakra-space-md)'
};